import { render } from "./FaqListForm.vue?vue&type=template&id=e157f892&lang=true"
import script from "./FaqListForm.vue?vue&type=script&lang=js"
export * from "./FaqListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__